module.exports = __webpack_public_path__ + "static/media/030.3060334f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/030.jpg
// module id = 537
// module chunks = 0